export default __webpack_public_path__ + "static/media/Shareholder-EN.55eea363.png";